import React, { PropsWithChildren } from 'react';
import ResultListSettings from '../../../components/molecules/ResultListSettings/ResultListSettings';
import { AToZCharacterNavigation } from './AToZCharacterNavigation';
import { Facets } from '../../../types/Facets';
import { contentSearchFacets } from '../../../_blocks/Search/ContentSearchBlock';

type AToZContainer = {
  showResultListSettings: boolean;
  facets?: Facets;
  characters: Record<string, unknown[]>;
  invisibleHeadline: string;
  characterHint: string;
  resetAllFiltersUrl?: {
    url: string;
  };
};

export function AToZContainer({
  showResultListSettings,
  facets,
  characters,
  invisibleHeadline,
  characterHint,
  children,
  resetAllFiltersUrl,
}: PropsWithChildren<AToZContainer>) {
  return (
    <div className="a-to-z-container">
      {facets && showResultListSettings &&
        <ResultListSettings
          facets={facets}
          type="content"
          wantedFacets={contentSearchFacets}
          resetAllFiltersUrl={resetAllFiltersUrl}
        />}
      <AToZCharacterNavigation
        pageListAToZ={characters}
        invisibleHeadline={invisibleHeadline}
        characterHint={characterHint}
      />
      {children}
    </div>
  );
}
